import Typed from 'typed.js';

export default (() => {
    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', () => {
        // Find the element that contains the dynamic string pattern
        const targetElements = document.querySelectorAll('[data-typed]');

        targetElements.forEach((targetElement) => {
            if (targetElement) {
                const textContent = targetElement.getAttribute('data-typed');

                if (textContent) {
                    const strings = textContent
                        .split('|')
                        .map((s) => s.trim().replaceAll('**', ''))
                        .filter((s) => s.length > 0);

                    if (strings.length > 0) {
                        // Find the string that creates the tallest text block
                        const longestString = strings.reduce((a, b) => {
                            // Function to measure height with a given string
                            const measureHeightWithString = (str) => {
                                // Get the parent element and its width
                                const parentElement = targetElement.parentElement;
                                const parentWidth = parentElement.offsetWidth;

                                // Create a test div with the same width as the parent
                                const testDiv = document.createElement('div');
                                testDiv.style.position = 'absolute';
                                testDiv.style.visibility = 'hidden';
                                testDiv.style.top = '-9999px';
                                testDiv.style.left = '-9999px';
                                testDiv.style.width = parentWidth + 'px';

                                // Copy text styles from the target element
                                const targetStyles = window.getComputedStyle(targetElement);
                                testDiv.style.fontSize = targetStyles.fontSize;
                                testDiv.style.fontFamily = targetStyles.fontFamily;
                                testDiv.style.fontWeight = targetStyles.fontWeight;
                                testDiv.style.lineHeight = targetStyles.lineHeight;
                                testDiv.style.letterSpacing = targetStyles.letterSpacing;
                                testDiv.style.textAlign = targetStyles.textAlign;
                                testDiv.style.whiteSpace = targetStyles.whiteSpace;
                                testDiv.style.wordWrap = targetStyles.wordWrap;
                                testDiv.style.wordBreak = targetStyles.wordBreak;
                                testDiv.style.overflowWrap = targetStyles.overflowWrap;
                                testDiv.style.padding = targetStyles.padding;
                                testDiv.style.margin = targetStyles.margin;
                                testDiv.style.boxSizing = targetStyles.boxSizing;

                                // Set the text content - replace the pattern with the string
                                const fullText = targetElement.parentElement.textContent.replace(
                                    /\|\[([^\]]+)\]\|/,
                                    str
                                );
                                testDiv.textContent = fullText;

                                // Add to DOM to measure
                                document.body.appendChild(testDiv);

                                // Get the height
                                const height = testDiv.offsetHeight;

                                // Debug logging
                                console.log(
                                    `String: "${str}" -> Height: ${height}px (Width: ${parentWidth}px)`
                                );

                                // Clean up
                                document.body.removeChild(testDiv);

                                return height;
                            };

                            // Measure heights for both strings
                            const heightA = measureHeightWithString(a);
                            const heightB = measureHeightWithString(b);

                            console.log(
                                `Comparing: "${a}" (${heightA}px) vs "${b}" (${heightB}px)`
                            );

                            // Return string that creates the tallest text block
                            return heightA > heightB ? a : b;
                        });

                        targetElement.textContent = longestString;

                        // Calculate the height of the entire text block and set it inline on the parent element
                        targetElement.classList.remove('hidden');
                        const parentElement = targetElement.parentElement;
                        const height = parentElement.offsetHeight;
                        parentElement.style.height = height + 'px';

                        targetElement.textContent = '';

                        new Typed(targetElement, {
                            strings: strings,
                            typeSpeed: 50,
                            loop: true,
                            showCursor: true,
                            backSpeed: 20,
                            backDelay: 3000
                        });
                    }
                }
            }
        });
    });
})();
